"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var CardEditorContainer_1 = require("../../../../../../../../shared/components/containers/CardEditorContainer");
var CardRowSelectEditor_1 = require("../../../../../../../../shared/components/editors/CardRowSelectEditor");
var CardRowTextEditor_1 = require("../../../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowButtonSet_1 = require("../../../../../../../../shared/components/editors/CardRowButtonSet");
var BonusTournamentGamesEditor = /** @class */ (function (_super) {
    __extends(BonusTournamentGamesEditor, _super);
    function BonusTournamentGamesEditor(props) {
        return _super.call(this, props) || this;
    }
    BonusTournamentGamesEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    cms_gameset_game_id: _item.gameprovider_gameset_game_id,
                    gws_game_title: _item.gws_game_title,
                    description: _item.description
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Турниры", "Изменить игру турнира"]);
                });
            }
        }
        else {
            this.setState({
                cms_gameset_game_id: 0,
                gws_game_title: "",
                description: ""
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Турниры", "Добавить игру турнира"]);
            });
        }
        this.doReSetRules();
    };
    BonusTournamentGamesEditor.prototype.doReSetRules = function () {
        this.setState({
            gws_game_rules: { isError: false }
        });
    };
    BonusTournamentGamesEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((this.state.cms_gameset_game_id <= 0) || (this.state.gws_game_title.length === 0)) {
            this.setState({ gws_game_rules: { isError: true, errorMessage: "Игра не выбрана!" } });
            return false;
        }
        return true;
    };
    BonusTournamentGamesEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                gameprovider_gameset_game_id: this.state.cms_gameset_game_id,
                bonus_tournament_id: this.props.rootRecord.key,
                description: this.state.description
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Игра турнира добавлена!");
            });
        }
    };
    BonusTournamentGamesEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                gameprovider_gameset_game_id: this.state.cms_gameset_game_id,
                key: this.props.record.key,
                description: this.state.description
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Игра турнира изменена!");
            });
        }
    };
    BonusTournamentGamesEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    BonusTournamentGamesEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Добавить игру турнира";
        }
        else {
            return "Изменить игру турнира";
        }
    };
    BonusTournamentGamesEditor.prototype.getDownButtons = function () {
        return (React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) }));
    };
    BonusTournamentGamesEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 350 },
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Игра:", placeholder: "Выберите игру" }, value: { key: this.state.cms_gameset_game_id, value: this.state.gws_game_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        cms_gameset_game_id: newVal.key,
                        gws_game_title: newVal.value,
                        gws_game_rules: { isError: false }
                    });
                }, items: this.props.availGames, required: true, rules: this.state.gws_game_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Описание:", placeholder: "Введите описание" }, value: this.state.description, onValueChanged: function (newVal) {
                    _this.setState({
                        description: newVal
                    });
                } }),
            this.getDownButtons()));
    };
    return BonusTournamentGamesEditor;
}(React.Component));
exports.default = BonusTournamentGamesEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_tournament/ui/component/options/games/BonusTournamentsGamesEditor.tsx
// module id = 2513
// module chunks = 0